import {LeftOutlined} from '@ant-design/icons';

type RevisedOrderNoticeProps = {
  onClick: () => void;
};

const RevisedOrderNotice: React.FC<RevisedOrderNoticeProps> = ({onClick}) => {
  return (
    <div className="m-2.5 flex flex-col rounded-lg bg-yellow-cream p-2.5">
      <p className="text-body-sm text-gray-09">
        این سفارش اصلاح شده است. تغییرات سفارش نسبت به فاکتور اصلی را می‌توانید مشاهده کنید.
      </p>
      <button
        type="button"
        className="mt-3.75 flex items-center justify-end gap-1 text-body-sm text-gray-09 underline"
        onClick={onClick}
      >
        مشاهده فاکتورهای قبلی
        <LeftOutlined aria-hidden />
      </button>
    </div>
  );
};

export default RevisedOrderNotice;
